export default __webpack_public_path__ + "static/MetadataImage-b0285eb7207c8436231bc0a070549f5f.png";